(function () {
  var menus = document.querySelectorAll('[data-native-mega-menu]');

  if (!menus.length) {
    return;
  }

  function setMegaTop(rootItem) {
    var mega = rootItem.querySelector('.bj-native-mega__mega');
    if (!mega) {
      return;
    }

    var rect = rootItem.getBoundingClientRect();
    mega.style.setProperty('--bj-menu-top', Math.round(rect.bottom) + 'px');
  }

  function closeSiblings(rootItem) {
    var parent = rootItem.parentElement;
    if (!parent) {
      return;
    }

    parent.querySelectorAll('.bj-native-mega__root-item.is-open').forEach(function (item) {
      if (item !== rootItem) {
        item.classList.remove('is-open');
        var button = item.querySelector('[aria-expanded]');
        if (button) {
          button.setAttribute('aria-expanded', 'false');
        }
      }
    });
  }

  menus.forEach(function (menu) {
    menu.querySelectorAll('.bj-native-mega__root-item--has-mega').forEach(function (rootItem) {
      var button = rootItem.querySelector('.bj-native-mega__root-link');

      rootItem.addEventListener('pointerenter', function () {
        setMegaTop(rootItem);
      });

      rootItem.addEventListener('focusin', function () {
        setMegaTop(rootItem);
      });

      if (button && button.tagName === 'BUTTON') {
        button.addEventListener('click', function () {
          var isOpen = rootItem.classList.toggle('is-open');
          closeSiblings(rootItem);
          setMegaTop(rootItem);
          button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        });
      }
    });

    menu.querySelectorAll('[data-native-mega-tabs]').forEach(function (tabSet) {
      var tabs = tabSet.querySelectorAll('[data-tab-target]');
      var panels = tabSet.querySelectorAll('[data-tab-panel]');

      tabs.forEach(function (tab) {
        function activate() {
          var target = tab.getAttribute('data-tab-target');

          tabs.forEach(function (item) {
            var active = item === tab;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-selected', active ? 'true' : 'false');
          });

          panels.forEach(function (panel) {
            panel.classList.toggle('is-active', panel.getAttribute('data-tab-panel') === target);
          });
        }

        tab.addEventListener('pointerenter', activate);
        tab.addEventListener('focus', activate);
        tab.addEventListener('click', activate);
      });
    });
  });

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-native-mega-menu]')) {
      return;
    }

    document.querySelectorAll('.bj-native-mega__root-item.is-open').forEach(function (item) {
      item.classList.remove('is-open');
      var button = item.querySelector('[aria-expanded]');
      if (button) {
        button.setAttribute('aria-expanded', 'false');
      }
    });
  });
})();
